module.exports = __webpack_public_path__ + "media/images/application/template/logos/constructionline-logo-fb133f5ccf4e1b233fdd3785d82917c1.png";